module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Reading the Gospels with Karl Barth")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack-001"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("My hearty thanks are extended to all who assisted in planning and organizing the Karl Barth Conference held in Princeton in June 2015. Special thanks go to the staff of the Center for Barth Studies at Princeton Theological Seminary, and above all to its expert and energetic curator, Kait Dugan, and her equally able assistant, Sara Misgen, who together guided every practical and technical aspect of the conference with grace and skill.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thanks also to Craig Barnes, president of Princeton Theological Seminary, for his strong support of the project and good advice on many matters; to Amy Ehlin, director of conferences and hospitality, for her efficiency and cheerfulness in overseeing the undertaking; to the facilities and technical teams of the Seminary for readying its buildings—including its stunning new library—for four days of rich theological discussion, an all-Mozart concert, and a fascinating slide lecture on Matthias Grünewald’s Isenheim Altarpiece by Professor Karlfried Froehlich; and to Kate Skrebutenas, Princeton Seminary’s reference librarian, for her invaluable help on all matters bibliographical. Finally, a special thanks to the plenary lecturers and to the presenters and moderators of afternoon discussion sessions whose able leadership and spirited interactions with conference participants assured its success.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This volume is dedicated to Jürgen Moltmann in grateful recognition of his seminal contributions to theology and church for more than half a century.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466fc50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0